<template>
    <div class="fb-group" style="font-size: 13px; margin: 0 auto; padding: 10px;">
        <h2 v-if="group">
            <a :href="'https://facebook.com/' + gid" class="fb-post-name" target="_blank">
                {{ group.name }}
            </a>
        </h2>
        <p v-if="group" style="font-size: 13px; text-align: left">
            {{ group.description }}
        </p>
        <img v-if="group && group.cover" :src="group.cover.source" style="max-width: 600px"/>

        <b-table small striped :fields="fields" :items="users">
            <template slot="index" slot-scope="data">
                {{data.index + 1}}
            </template>
            <template slot="score" slot-scope="data">
                {{ data.item.score }}
            </template>
            <template slot="do_talks" slot-scope="data">
                <router-link :to="data.item.id" target="_blank">
                    {{ data.item.do_talks }}
                </router-link>
            </template>
            <template slot="work_education_histories" slot-scope="data">
                <div style="text-align: left">
                    <div v-for="item in data.item.location_cities">
                        ⚑ {{item}}
                    </div>
                    <div v-if="data.item.birthday">
                        ✺ {{ data.item.birthday }}
                    </div>
                    <a :href="'https://facebook.com/' + data.item.id" target="_blank" class="fb-post-name">
                        {{ data.item.name }}
                    </a>
                    <br/>
                    <img :src="data.item.pic_big" width="90px" height="90px"
                         style="border: 1px solid #d6d6d6; border-radius: 5%;"/>
                    <br/>

                    <span v-for="item in data.item.work_histories">
                        ⚒ {{item}}
                        <br/>
                    </span>

                    <span v-for="item in data.item.education_histories">
                        ☢ {{item}}
                        <br/>
                    </span>
                </div>
                <br/>
                <fb-user-group-talks :gid="gid" :uid="data.item.id"></fb-user-group-talks>
            </template>
        </b-table>

        <div v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10">
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import infiniteScroll from 'vue-infinite-scroll'
    import FBHelper from '@/libs/fb-helper';
    import FBMongo from '@/libs/fb-mongo';

    export default {
        data: () => ({
            gid: '',
            limit: undefined,
            group: undefined,
            fields: [
                {
                    key: 'index',
                    label: '#',
                    sortable: true
                },
                {
                    key: 'score',
                    label: 'Score',
                    sortable: true,
                },
                {
                    key: 'get_reactions',
                    label: 'Get Reactions',
                    sortable: true,
                },
                {
                    key: 'do_talks',
                    label: 'Talks',
                    sortable: true,
                },
                {
                    key: 'work_education_histories',
                    label: 'Work & Education',
                    'class': 'work_education_histories'
                },
            ],
            users: [],
            busy: false,
            next_page: undefined,
            errors: undefined,
        }),
        directives: {infiniteScroll},
        components: {
            'fb-post': () => import('../post'),
            'fb-user-group-talks': () => import('../user-group-talks')
        },

        created() {
            document.title = 'Group Users Stats: '
            this.token = localStorage.token
            this.gid = this.$route.params.gid
            this.limit = this.$route.query.limit || 300

            if (!this.token || !this.gid) return

            FBHelper.getGroupInfo(this.gid).then(group => {
                document.title = 'Group Users Stats: ' + group.name
                this.group = group
            })
        },
        methods: {
            async loadMore() {
                this.busy = true

                var response
                if (this.next_page === undefined) {
                    response = await FBMongo.fetchStatsUsers({gid: this.gid, limit: this.limit})
                } else {
                    response = await FBMongo.fetchStatsUsers({link: this.next_page})
                }

                this.next_page = response.meta.next_page
                var users = response.data

                await this.fillInfoUsers(users)

                // _.remove(users, user => {
                //     if ('female' === user.sex) return true
                //     if (user.current_location && user.current_location.latitude < 17) {
                //         return true
                //     }
                //     if (user.hometown_location && user.hometown_location.latitude < 17) {
                //         return true
                //     }
                //
                //     return false
                // });

                this.users.push(...users)

                this.busy = false
            },


            async fillInfoUsers(statsUsers) {
                var uids = statsUsers.map(statsUser => statsUser.id)
                var response = await FBHelper.fetchInfoUsers({uids: uids});
                var infoUsers = response.data

                var infoUsersMap = new Map(infoUsers.map(infoUser => [infoUser.uid.toString(), infoUser]));

                statsUsers.forEach(statsUser => {
                    var infoUser = infoUsersMap.get(statsUser.id)
                    if (infoUser === undefined) return

                    Object.assign(statsUser, infoUser)

                    var location_cities = []
                    if (infoUser.current_location && infoUser.current_location.city) {
                        location_cities.push(infoUser.current_location.city)
                    }
                    if (infoUser.hometown_location && infoUser.hometown_location.city) {
                        location_cities.push(infoUser.hometown_location.city)
                    }

                    var work_histories = []
                    _.forEach(infoUser.work_history, item => {
                        var str = ''

                        if (_.has(item, 'location.city')) {
                            str += _.get(item, 'location.city') + ' - '
                        }

                        if (_.has(item, 'position')) {
                            str += _.get(item, 'position') + ' - '
                        }
                        if (_.has(item, 'company_name')) {
                            str += _.get(item, 'company_name')
                        }

                        var start_date = _.get(item, 'start_date')
                        var end_date = _.get(item, 'end_date')

                        if (start_date === undefined || start_date === '0000-00') {
                            start_date = 'unknown'
                        }
                        if (end_date === undefined || end_date === '0000-00') {
                            end_date = 'unknown'
                        }

                        str += ' (' + start_date + ' ~ ' + end_date + ') '
                        work_histories.push(str)
                    })


                    var education_histories = []
                    _.forEach(infoUser.education_history, item => {
                        var str = ''

                        if (item.concentrations) {
                            str += _.join(item.concentrations, ' & ')
                            str += ' '
                        }

                        if (item.name) {
                            str += ' @' + item.name
                        }

                        if (item.school_type) {
                            str += ' (' + item.school_type + ') '
                        }

                        if (item.year) {
                            str += ' - ' + item.year
                        }

                        education_histories.push(str)

                    })

                    statsUser.location_cities = location_cities
                    statsUser.work_histories = work_histories
                    statsUser.education_histories = education_histories
                })
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h1, h2 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #3c8dbc;
    }

    fb-group {
        max-width: 600px;
        margin: 0 auto;
    }

    .work_education_histories {
        max-width: 200px;
    }
</style>



// WEBPACK FOOTER //
// src/components/fb/group/stats.vue